const __request = require(`./__request/__request_contentType_form`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/wallet/account/exportAccountFlow',
        data: data
    }
    return __request(pParameter)
}
export default request